import { observable } from "mobx";
import { Type } from "class-transformer";
import DateTimeOffsetRangeRequest from "./dateTimeOffsetRangeRequest";
import type { EntityValidationRules } from "services/validationService";
import { addDays, endOfDay, isSameDay, subDays } from "date-fns";
import { startOfEDAZ } from "config";
import { startOfCzechDay } from "utils/dateUtils";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class LustrationReportsSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  @Type(() => Date)
  _eventOccurredAtSinceDate!: Date;

  @observable
  @Type(() => Date)
  _eventOccurredAtUntilDate!: Date;

  @observable
  @Type(() => DateTimeOffsetRangeRequest)
  eventOccurredAtRange?: DateTimeOffsetRangeRequest;
}

export const LustrationReportSearchValidationRules: EntityValidationRules<LustrationReportsSearchRequest> = {
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
    isLength: {
      min: 1,
      optional: true,
    },
  },
  _eventOccurredAtSinceDate: {
    isBefore: {
      condition: (entity: LustrationReportsSearchRequest) =>
        isSameDay(entity._eventOccurredAtUntilDate, entity._eventOccurredAtSinceDate)
          ? endOfDay(addDays(entity._eventOccurredAtUntilDate, 1))
          : entity._eventOccurredAtUntilDate,
    },
    isAfter: {
      after: endOfDay(subDays(startOfEDAZ, 1)),
    },
  },
  _eventOccurredAtUntilDate: {
    isBefore: {
      before: startOfCzechDay(),
    },
    isAfter: {
      condition: (entity: LustrationReportsSearchRequest) =>
        isSameDay(entity._eventOccurredAtUntilDate, entity._eventOccurredAtSinceDate)
          ? endOfDay(subDays(entity._eventOccurredAtSinceDate, 1))
          : entity._eventOccurredAtSinceDate,
    },
  },
};
